import React, {useEffect, useState} from "react";
import infoBackground from "./infoBackground.png";

import infoDesktop from "./info_desktop.svg";
import infoMobile from "./info_mobile.svg";
import useIsPc from "../../hooks/useIsPc";
import useIsMobile from "../../hooks/useIsMobile";
import useIsTablet from "../../hooks/useIsTablet";
import "./infopage.css";
import { useLayoutContext } from "../../layout/layout-provider";

type InfoPageGeneratedPageProps = {
  useHomeLayers?: boolean;
};

const InfoPageGeneratedPage: React.FC<InfoPageGeneratedPageProps> = ({
  useHomeLayers = false,
}) => {
  const isPC = useIsPc();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  const {
    secondLayerHidden,
    secondLayerHomeHidden,
    shouldInfoFadeOut,
    setShouldInfoFadeOut,
  } = useLayoutContext();
  const [panelAvailability, setPanelAvailability] = useState(false);

  const isLayerHidden = useHomeLayers
    ? secondLayerHomeHidden
    : secondLayerHidden;

  useEffect(() => {
    const footer = document.querySelector(".footer"); // o document.getElementById('footer');
    const infoPanel = document.getElementById("info-panel");

    if (footer && infoPanel) {
      const footerHeight = footer.getBoundingClientRect().height;
      const offset = 10; // Puoi impostare il tuo offset desiderato

      infoPanel.style.position = "absolute";
      infoPanel.style.bottom = `${footerHeight + offset}px`;
    }
  }, []);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setPanelAvailability(true);
    }, 1500);

    return () => {
      clearTimeout(timerId); // Pulisce il timer se il componente viene smontato prima che scada
    };
  }, []);

  useEffect(() => {
    setShouldInfoFadeOut(false);
  }, [setShouldInfoFadeOut]);

  return (
    <>
      {panelAvailability && (
        <>
          <div
            className={`info-page ${
              isPC ? "" : "mobile-tablet-layout-image"
            } absolute top-0
            ${!isLayerHidden ? "fade-in" : shouldInfoFadeOut ? "fade-out-z-0" : "hidden-z-0"}`}
            id="info-panel"
          >
            {isPC && (
              <>
                <img src={infoDesktop} className={"infoimage"} />
              </>
            )}
            {(isTablet || isMobile) && (
              <>
                <img src={infoMobile} className={"infoimage"} />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default InfoPageGeneratedPage;

/*
 <div className={`info-page-header ${isPC ? '' : 'mobile-tablet-header'} ${secondLayerHidden ? 'fade-out delay-01' : 'fade-in delay-01'}`}>
                    <h1>INFO</h1>
                </div>
                <div className={`info-page-content ${isPC ? '' : 'mobile-tablet-content'}`}>
                    <div>
                        Questi simboli rappresentano le lettere o i suoni nel tuo nome, ma in forma di scrittura usata nell'antico Egitto. Ricorda che questa conversione è più ludica che storica, quindi i geroglifici generati sono solo un modo divertente e creativo per vedere il tuo nome in un alfabeto molto diverso dal nostro. Vuoi sapere come funziona la scrittura geroglifica? Non perderti il video nella galleria della scrittura!
                    </div>
                    <div>
                        These symbols represent the letters or sounds in your name, but in the form of writing used in ancient Egypt. Remember, this conversion is more playful than historical, so the generated hieroglyphs are just a fun and creative way to see your name in an alphabet very different from our own. Want to know how hieroglyphic writing works? Don't miss the video in the Gallery of Writing!
                    </div>
                </div>
*
* */
